// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif !important;
}

/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.createUser_dashboard__17yXH {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px 30px 80px 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  overflow-y: auto;
}

.createUser_dashboardContain__frg-z {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.createUser_bodythemedark__kzglF .createUser_dashboardContain__frg-z,
.createUser_bodythemedark__kzglF .createUser_dashboard__17yXH,
.createUser_bodythemedark__kzglF .createUser_cont2__AUUWk {
  background-Color: #0f1824;
}

.createUser_top_header__5x0WP .createUser_top_header_inner__WgBlR {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.createUser_cont2__AUUWk {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.createUser_subLink__zgl5e svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.createUser_footer__r8ySe {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.createUser_bodythemelight__xGFCq {
  background-color: #fff;
  padding-top: 90px;
}

.createUser_bodythemedark__kzglF {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.createUser_headerthemelight__9RK3i {
  background-color: #fff;
}

.createUser_headerthemedark__rbDM\\+ {
  background-color: #132337;
}

.createUser_top_header__5x0WP {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1;
}

/* 
LEFT MENU THEME CHANGE
*/
.createUser_menuthemelight__EgxpM {
  background-color: #fff;
}

.createUser_menuthemedark__e-R6\\+ {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.createUser_menulinklight__Dv14u span {
  color: #666666 !important;
}

.createUser_menulinklight__Dv14u a {
  color: #CBCBCB !important;
}

.createUser_menulinklight__Dv14u:hover span, .createUser_menulinklight__Dv14u:hover a {
  color: #fff !important;
}

.createUser_menulinkdarkSelected__84zB7 {
  background-color: #1c2e45;
  color: #fff;
}

.createUser_menuthemelight__EgxpM .createUser_menulinklightSelected__34KWF {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #205440;
}

.createUser_menulinkdark__gEw\\+k {
  color: #60677e !important;
}

.createUser_menulinklight__Dv14u:hover {
  color: #fff !important;
  background-color: #205440;
}

.createUser_menulinkdark__gEw\\+k:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.createUser_headinglight__pb5IY {
  color: #60677e;
}

.createUser_headingdark__\\+wZmd {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.createUser_searchboxlight__it2cD {
  background-color: #fff;
  border: none;
}

.createUser_searchboxdark__zk723 {
  background-color: #132337;
  color: #fff;
  border: none;
}

.createUser_searchboxdark__zk723::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.createUser_tableheadlight__zJuDZ {
  background-color: #205440;
  border-radius: 5px 5px 0px 0px;
}

.createUser_tableheadlight__zJuDZ th {
  color: #fff;
}

thead .createUser_tableheadlight__zJuDZ th:first-child,
thead .createUser_tableheaddark__93g9w th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .createUser_tableheadlight__zJuDZ th:last-child,
thead .createUser_tableheaddark__93g9w th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.createUser_table__\\+vT8B.createUser_table-borderless__zuaEC {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.createUser_tableheaddark__93g9w {
  background-color: #1e1e2d;
  color: #fff;
}

.createUser_table-borderless__zuaEC tr:nth-child(even) {
  background-color: #F9FAFB;
}

.createUser_table-borderless__zuaEC .createUser_left-section__m6jeo {
  padding-top: 10px;
}

.createUser_tablebodylight__RQHFo td,
.createUser_tablebodydark__\\+wUQe td {
  padding: 1rem 1rem !important;
}

.createUser_tablebodylight__RQHFo {
  background-color: #fff;
}
.createUser_tablebodylight__RQHFo:hover {
  background-color: #ddecf9;
  cursor: pointer;
}

.createUser_tablebodydark__\\+wUQe {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.createUser_tablebodydark__\\+wUQe:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: pointer;
}

/* 
PAGINATION THEME COLOR
*/
.createUser_paginationlight__vk0cl {
  color: #60677e !important;
  font-size: 13px !important;
}

.createUser_paginationdark__Xw1eA {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.createUser_formthemelight__GNCil {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.createUser_formthemedark__c2wJu {
  background-color: #1e1e2d;
  color: #60677e !important;
  font-size: 14px;
}
.createUser_formthemedark__c2wJu ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.createUser_viewformlight__5iQFa {
  background-color: #f3f6f9;
}

.createUser_permissionboxlight__Xbi1l {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.createUser_permissionboxdark__tZnnH {
  background-color: #151521;
  border: solid 1px #242434;
}

.createUser_errormsgclr__fZqt\\+ {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.createUser_graphclrlight__w4ooJ {
  background-color: #fff;
}

.createUser_graphclrdark__BbVKi {
  background-color: #1e1e2d;
}

/* 
Counter theme
*/
#createUser_card1bglight__0e\\+GH {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#createUser_card1bglight__0e\\+GH:hover {
  background: #f7fffc;
}

#createUser_card1bgdark__olYL6 {
  background: #392f28;
}

#createUser_card1bgdark__olYL6:hover {
  background: #f7fffc;
}

#createUser_card2bglight__vgbXZ {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#createUser_card2bglight__vgbXZ:hover {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #f7fffc;
}

#createUser_card2bgdark__rXsmA {
  background: #1c3238;
}

#createUser_card3bglight__WUTme {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#createUser_card3bglight__WUTme:hover {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #f7fffc;
}

#createUser_card3bgdark__hI9mR {
  background: #3a2434;
}

#createUser_card4bglight__1\\+mIM {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#createUser_card4bglight__1\\+mIM:hover {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #f7fffc;
}

#createUser_card4bgdark__1zDPP {
  background: #2f264f;
}

#createUser_card1bgdark__olYL6 a, #createUser_card1bgdark__olYL6 p,
#createUser_card2bgdark__rXsmA a, #createUser_card2bgdark__rXsmA p,
#createUser_card3bgdark__hI9mR a, #createUser_card3bgdark__hI9mR p,
#createUser_card4bgdark__1zDPP a, #createUser_card4bgdark__1zDPP p {
  color: #fff;
}

/* 
Action button theme
*/
.createUser_actionbtnlight__DmVva {
  color: rgba(70, 71, 91, 0.8705882353);
}

.createUser_actionbtndark__gMi4o {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.createUser_profiledropdownlight__2lQzy {
  background-color: #fff;
}

.createUser_profiledropdowndark__Mvb9k {
  background-color: #151521;
}

.createUser_settingsection__JFGnn #createUser_addform__c-1fM.createUser_formthemedark__c2wJu .createUser_savebtn__uS9j\\+ {
  background-color: #0a2574;
  color: #fff;
}

#createUser_addform__c-1fM.createUser_formthemedark__c2wJu .createUser_savebtn__uS9j\\+ {
  background-color: #0a2574;
  color: #fff;
}

.createUser_profile_conatiner__RVAU1 {
  border-radius: 5px !important;
}

.createUser_bodythemedark__kzglF .createUser_ag-theme-alpine__d2lH0 .createUser_ag-row__GzqWr {
  background: #000 !important;
}

.createUser_bodythemedark__kzglF .createUser_formbtn__7DbRY {
  background-color: #0a2574;
}

.createUser_bodythemedark__kzglF .createUser_resetbtn__wCOLc {
  color: #fff;
  background-color: transparent;
  border: solid 1px #0a2574;
}

.createUser_bodythemedark__kzglF .createUser_resetbtn__wCOLc:hover {
  background-color: #0a2574;
}

.createUser_headingdark__\\+wZmd span {
  background-color: #132337;
}

.createUser_resetbtn__wCOLc {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #205440;
  color: #205440;
  min-width: 113px;
}

.createUser_resetbtn__wCOLc:hover,
.createUser_resetbtn__wCOLc:active,
.createUser_resetbtn__wCOLc:focus {
  background-color: #205440;
  color: #fff;
}

.createUser_addBtn__2U3kk {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.createUser_addBtn__2U3kk svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.createUser_addBtn__2U3kk:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.createUser_cust_addBtn__Z-wC0.createUser_addBtn__2U3kk svg {
  top: 2px;
}

.createUser_deleteBtn__E04aD {
  min-width: auto;
  padding: 10px 0;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.createUser_deleteBtn__E04aD {
  min-width: auto !important;
  height: 50px !important;
  background-color: #205440 !important;
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border: none !important;
  padding: 0.375rem 1rem !important;
}

.createUser_deleteBtn__E04aD:active, .createUser_deleteBtn__E04aD:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.createUser_deleteBtn__E04aD svg {
  position: relative;
  top: -2px;
}

.createUser_deleteBtn__E04aD:hover,
.createUser_deleteBtn__E04aD:active,
.createUser_deleteBtn__E04aD:focus {
  background-color: #205440 !important;
  color: #fff;
  border: none;
}

.createUser_confirmBtn__3LX0U {
  background-color: #205440;
}

.createUser_confirmBtn__3LX0U:hover,
.createUser_confirmBtn__3LX0U:active,
.createUser_confirmBtn__3LX0U:focus {
  background-color: #205440;
}

.createUser_confirmBtn__3LX0U svg {
  top: 0;
}

.createUser_back_dlt__T-BCR {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.createUser_delPopContainer__ernWk .createUser_modal-body__MHQGK {
  padding: 25px;
  text-align: center;
}

.createUser_delPopContainer__ernWk .createUser_delet_icon__fXzxB {
  margin-bottom: 11px;
}

.createUser_delPopContainer__ernWk p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.createUser_arrowback__lG5yY svg {
  fill: #000;
}

.createUser_bodythemedark__kzglF .createUser_arrowback__lG5yY {
  background-color: #0a2574;
  color: #fff;
}

.createUser_bodythemedark__kzglF .createUser_arrowback__lG5yY svg {
  fill: #fff;
}

.createUser_bodythemedark__kzglF .createUser_drpdwn_btn__DhdKo {
  background-color: #132337;
}

.createUser_bodythemedark__kzglF .createUser_empname__ZhmHW {
  color: #60677e !important;
}

.createUser_bodythemedark__kzglF .createUser_navitemli__3afjv a {
  background-color: transparent;
  border: solid 1px #0a2574;
  color: #fff;
}

.createUser_bodythemedark__kzglF .createUser_tabnavli__rjxZW a.createUser_settingsgeneral__lu7P9,
.createUser_bodythemedark__kzglF .createUser_tabnavli__rjxZW a.createUser_settingslinks__RRBrS:hover {
  background-color: #0a2574;
  color: #fff;
}

.createUser_bodythemedark__kzglF .createUser_tabnavli__rjxZW a.createUser_settingslinks__RRBrS {
  background-color: transparent;
  border: solid 1px #0a2574;
  color: #fff;
}

@media only screen and (max-width: 1200px) {
  .createUser_tableheadlight__zJuDZ th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) {
  .createUser_dashboard__17yXH {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 998px) {
  #createUser_dashboardcont2__nLo41 {
    height: auto !important;
  }
}
@media only screen and (max-width: 767px) {
  .createUser_sectionright__v-V2q {
    float: unset !important;
  }
  .createUser_dashboard__17yXH {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .createUser_cont2__AUUWk {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 20px 10px !important;
  }
  .createUser_bodythemelight__xGFCq, .createUser_bodythemedark__kzglF {
    padding-top: 165px;
  }
}
@media (min-width: 576px) {
  .createUser_exer_modal_contain__KDFCs .createUser_modal-dialog__yVYfJ {
    max-width: 1055px;
  }
  .createUser_delPopContainer__ernWk .createUser_modal-dialog__yVYfJ {
    max-width: 350px;
  }
}
#createUser_addform__c-1fM {
  width: 100%;
  border-radius: 5px;
  margin-top: 30px;
  padding-bottom: 30px;
}
#createUser_addform__c-1fM #createUser_addheading__l\\+Q6E {
  font-size: 18px;
  margin-bottom: 20px;
}
#createUser_addform__c-1fM .createUser_inputbox1__X2UXw {
  padding: 10px;
  border: none;
  border-radius: 5px;
  width: 100%;
  background-color: #151521;
  color: #60677e;
}
#createUser_addform__c-1fM .createUser_dateinputbox__il7dU {
  background-color: #F5F6FA;
  border-radius: 5px;
  width: 100%;
  color: #1d1d1d;
  font-size: 14px;
}
#createUser_addform__c-1fM .createUser_dateinputbox1__k6IeO {
  border: none;
  border-radius: 5px;
  width: 100%;
  background-color: #151521;
  color: #60677e;
}
#createUser_addform__c-1fM .createUser_formbtn__7DbRY {
  background-color: #205440;
  color: white;
  border: none;
  width: 100px;
  font-size: 16px;
  padding: 11px;
  border-radius: 5px;
  margin-right: 10px;
}
#createUser_addform__c-1fM .createUser_formbtn__7DbRY:hover {
  background-color: rgba(37, 105, 109, 0.864);
}
#createUser_addform__c-1fM .createUser_resetbtn__wCOLc {
  margin-left: 10px;
  background-color: rgba(180, 184, 192, 0.3882352941);
  color: #212529;
  border: none;
  width: 100px;
  font-size: 16px;
  padding: 11px;
  border-radius: 5px;
}
#createUser_addform__c-1fM .createUser_resetbtn__wCOLc:hover {
  background-color: rgba(37, 105, 109, 0.864);
  color: #fff;
}
#createUser_addform__c-1fM ::placeholder {
  font-size: 14px;
  color: #60677e;
}
#createUser_addform__c-1fM .createUser_labeltext__vHsyR {
  color: #1d1d1d;
  font-size: 14px;
  font-weight: 500;
}
#createUser_addform__c-1fM .createUser_eyeicon__LLaA6 {
  margin-left: -30px;
  cursor: pointer;
}
#createUser_addform__c-1fM .createUser_arrowback__lG5yY {
  float: right;
  background-color: #dde2eb;
  padding: 10px;
  color: #205440;
  cursor: pointer;
  border-radius: 3px;
}
#createUser_addform__c-1fM .createUser_arrowback__lG5yY:hover {
  background-color: #205440;
  color: #fff;
}

@media only screen and (max-width: 600px) {
  #createUser_dashboardcont2__nLo41 {
    width: calc(100% - 50px);
    left: 50px;
    position: relative;
    padding: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/pages/users/createUser.module.scss"],"names":[],"mappings":"AAEA;EACE,8CAAA;ACAF;;ADGA;;EAAA;AAqCA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,4BAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAAA;EACA,gBAAA;AC3DF;;AD6DA;EACE,yBAAA;EACA,yBAlFO;EAmFP,kBAAA;AC1DF;;AD4DA;;;EAGE,yBAjEoB;ACQtB;;AD2DA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACxDF;;AD2DA;;CAAA;AAIA;EACE,wBAtCU;EAuCV,UAtCS;EAuCT,kBAAA;EACA,aA9CiB;EA+CjB,kBAAA;EACA,mBA1GO;EA2GP;;;GAAA;ACtDF;;AD4DA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACzDF;;AD8DA;EACE,YAAA;AC3DF;;AD8DA;EACE,sBA7FY;ACkCd;;AD8DA;;CAAA;AAGA;EACE,sBApGY;EAqGZ,iBAAA;AC3DF;;AD6DA;EACE,yBAnHgB;EAoHhB,iBAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBAhHY;ACsDd;;AD6DA;EACE,yBA/HgB;ACqElB;;AD4DA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;ACzDF;;AD4DA;;CAAA;AAGA;EACE,sBAnIY;AC0Ed;;AD2DA;EACE,yBAjJgB;ACyFlB;;AD2DA;;CAAA;AAGA;EACE,yBAAA;ACxDF;;AD2DA;EACE,yBAAA;ACxDF;;AD2DA;EACE,sBAAA;ACxDF;;AD2DA;EACE,yBAlKsB;EAmKtB,WA1JY;ACkGd;;AD0DA;EACE,sCAAA;EACA,sBAAA;EACA,yBA/Lc;ACwIhB;;AD0DA;EACE,yBAAA;ACvDF;;AD0DA;EACE,sBAAA;EACA,yBAxMc;ACiJhB;;AD0DA;EACE,yBArLsB;EAsLtB,WA7KY;ACsHd;;AD0DA;;CAAA;AAGA;EACE,cAjLe;AC0HjB;;AD0DA;EACE,cArLe;AC8HjB;;AD0DA;;CAAA;AAGA;EACE,sBA/LY;EAgMZ,YAAA;ACvDF;;AD0DA;EACE,yBA/MgB;EAgNhB,WArMY;EAsMZ,YAAA;ACvDF;;ADyDA;EACE,cAtMe;ACgJjB;;ADyDA;;CAAA;AAGA;EACE,yBAhPc;EAiPd,8BAAA;ACtDF;;ADwDA;EACE,WApNY;AC+Jd;;ADuDA;;EAEE,0BAAA;ACpDF;;ADsDA;;EAEE,0BAAA;ACnDF;;ADqDA;EACE,kBAAA;AClDF;;ADoDA;EACE,kBAAA;ACjDF;;ADmDA;EACE,oCAAA;EACA,gCAAA;AChDF;;ADmDA;EACE,yBAlOkB;EAmOlB,WA3OY;AC2Ld;;ADkDA;EACE,yBAAA;AC/CF;;ADiDA;EACE,iBAAA;AC9CF;;ADgDA;;EAEE,6BAAA;AC7CF;;AD+CA;EACE,sBAxPY;AC4Md;AD8CE;EACE,yBAAA;EACA,eAAA;AC5CJ;;AD+CA;EACC,0CAAA;EACC,cA9Pe;ACkNjB;AD8CE;EACE,yCAAA;EACA,eAAA;AC5CJ;;ADgDA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC7CF;;AD+CA;EACE,yBAAA;EACA,0BAAA;AC5CF;;AD+CA;;CAAA;AAGA;EACE,sBAzRY;EA0RZ,yBAAA;EACA,qDAAA;AC5CF;;AD8CA;EACE,yBAtRkB;EAuRlB,yBAAA;EACA,eAAA;AC3CF;AD6CE;EACE,cAhSa;ACqPjB;;ADgDA;;CAAA;AAGA;EACE,yBA/SgB;ACkQlB;;ADgDA;EACE,yBAAA;EACA,yBAAA;AC7CF;;AD+CA;EACE,yBAAA;EACA,yBAAA;AC5CF;;AD+CA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AC5CF;;AD+CA;;CAAA;AAGA;EACE,sBAlUY;ACsRd;;AD+CA;EACE,yBA9TkB;ACkRpB;;ADgDA;;CAAA;AAGA;EACE,iGAAA;EACA,sBA/UY;ACkSd;;AD+CA;EACE,mBAAA;AC5CF;;AD8CA;EACE,mBAAA;AC3CF;;AD6CA;EACE,mBAAA;AC1CF;;AD4CA;EACE,gGAAA;EACA,sBA5VY;ACmTd;;AD2CA;EACE,gGAAA;EACA,yBAAA;ACxCF;;AD0CA;EACE,mBAAA;ACvCF;;AD0CA;EACE,gGAAA;EACA,sBAxWY;ACiUd;;ADyCA;EACE,gGAAA;EACA,yBAAA;ACtCF;;ADyCA;EACE,mBAAA;ACtCF;;ADyCA;EACE,gGAAA;EACA,sBArXY;AC+Ud;;ADwCA;EACE,gGAAA;EACA,yBAAA;ACrCF;;ADuCA;EACE,mBAAA;ACpCF;;ADuCA;;;;EAIE,WAnYY;AC+Vd;;ADuCA;;CAAA;AAGA;EACE,qCAAA;ACpCF;;ADuCA;EACE,cA3Ye;ACuWjB;;ADwCA;;CAAA;AAGA;EACE,sBAAA;ACrCF;;ADwCA;EACE,yBAAA;ACrCF;;ADwCA;EACE,yBAtaqB;EAuarB,WA/ZY;AC0Xd;;ADuCA;EACE,yBA1aqB;EA2arB,WAnaY;AC+Xd;;ADuCA;EACE,6BAAA;ACpCF;;ADuCA;EACE,2BAAA;ACpCF;;ADuCA;EACE,yBAvbqB;ACmZvB;;ADuCA;EACE,WAnbY;EAobZ,6BAAA;EACA,yBAAA;ACpCF;;ADuCA;EACE,yBAjcqB;AC6ZvB;;ADwCA;EACE,yBAzcgB;ACoalB;;ADwCA;EACE,eAAA;EACA,gBAzec;EA0ed,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cAvec;EAwed,gBAAA;ACrCF;;ADuCA;;;EAGE,yBA7ec;EA8ed,WA9cY;AC0ad;;ADuCA;EACE,gBAAA;EACA,YAAA;EACA,WApdY;EAqdZ,yBA3eY;EA4eZ,YAAA;EACA,eAAA;EACA,gBA9fc;AC0dhB;;ADuCA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACpCF;;ADuCA;EACE,WAleY;EAmeZ,yBAzfY;EA0fZ,YAAA;ACpCF;;ADuCA;EACE,QAAA;ACpCF;;ADuCA;EACE,eAAA;EACF,eAAA;EACE,yBA7fW;EA8fX,WA/eY;EAgfZ,eAAA;EACA,gBAvhBc;EAwhBd,YAAA;ACpCF;;ADuCA;EACE,0BAAA;EACA,uBAAA;EACA,oCAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;EACA,iCAAA;ACpCF;;ADuCA;EACE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACpCF;;ADuCA;EACE,kBAAA;EACA,SAAA;ACpCF;;ADuCA;;;EAGE,oCAAA;EACA,WA/gBY;EAghBZ,YAAA;ACpCF;;ADuCA;EACE,yBApjBc;ACghBhB;;ADuCA;;;EAGE,yBA1jBc;ACshBhB;;ADuCA;EACE,MAAA;ACpCF;;ADwCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;ACrCF;;ADwCA;EACE,aAAA;EACA,kBAAA;ACrCF;;ADwCA;EACE,mBAAA;ACrCF;;ADwCA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;ACrCF;;ADwCA;EACE,UAAA;ACrCF;;ADwCA;EACE,yBApkBqB;EAqkBrB,WA7jBY;ACwhBd;;ADwCA;EACE,UAjkBY;AC4hBd;;ADwCA;EACE,yBAhlBgB;AC2iBlB;;ADwCA;EACE,yBAAA;ACrCF;;ADwCA;EACE,6BAAA;EACA,yBAAA;EACA,WA/kBY;AC0iBd;;ADwCA;;EAEE,yBA5lBqB;EA6lBrB,WArlBY;ACgjBd;;ADuCA;EACE,6BAAA;EACA,yBAAA;EACA,WA1lBY;ACsjBd;;ADwCA;EACE;IACE,gBAAA;ECrCF;AACF;ADuCA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;ECrCF;AACF;ADuCA;EACE;IACE,uBAAA;ECrCF;AACF;ADuCA;EACE;IACE,uBAAA;ECrCF;EDuCA;IACE,6BAAA;ECrCF;AACF;ADuCA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,6BAAA;ECrCF;EDuCA;IACE,kBAAA;ECrCF;AACF;ADwCA;EACE;IACI,iBAAA;ECtCJ;EDwCA;IACI,gBAAA;ECtCJ;AACF;AAlpBA;EAEI,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;AAmpBJ;AAjpBI;EACI,eAAA;EACA,mBAAA;AAmpBR;AAhpBI;EACI,aAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,yBD4BS;EC3BT,cDgCS;ACknBjB;AA/oBI;EACI,yBDRC;ECSD,kBAAA;EACA,WAAA;EACA,cDuBM;ECtBN,eAAA;AAipBR;AA/oBI;EACI,YAAA;EACA,kBAAA;EACA,WAAA;EACA,yBDaS;ECZT,cDiBS;ACgoBjB;AA9oBI;EACI,yBDuBW;ECtBX,YAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AAgpBR;AA9oBQ;EACI,2CDcS;ACkoBrB;AA7oBI;EACI,iBAAA;EACA,mDAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;AA+oBR;AA7oBI;EACI,2CAAA;EACA,WAAA;AA+oBR;AA5oBI;EACI,eAAA;EACA,cDjBS;AC+pBjB;AA5oBI;EACI,cDtBM;ECuBN,eAAA;EACA,gBAAA;AA8oBR;AA5oBM;EACE,kBAAA;EACA,eAAA;AA8oBR;AA3oBM;EACE,YAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AA6oBR;AA3oBU;EACE,yBAAA;EACA,WAAA;AA6oBZ;;AAzoBE;EACE;IACI,wBDlBI;ICmBJ,UDlBG;ICmBH,kBAAA;IACA,aD1BW;ECsqBjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: \"Urbanist\", sans-serif !important;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #205440;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #1e1e2d;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #205440;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: calc(100% - 320px);\n  position: relative;\n  left: 290px;\n  padding: 30px 30px 80px 30px;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: #F5F6FA;\n  overflow-y: auto;\n}\n.dashboardContain { \n  width: calc(100% - 320px);\n  background-Color:$mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard, \n.bodythemedark .cont2 { \n  background-Color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1; \n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span, .menulinklight:hover a { \n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark {\n  color: $lightthemetext !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n} \nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child  {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n} \ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless{\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td, \n.tablebodydark td {\n  padding: 1rem 1rem !important;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: pointer;\n  }\n}\n.tablebodydark {\n /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: pointer;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: #151521;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n#card1bglight:hover {\n  background: #f7fffc;\n}\n#card1bgdark {\n  background: #392f28;\n}\n#card1bgdark:hover {\n  background: #f7fffc;\n}\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n#card2bglight:hover {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: #f7fffc;\n}\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n#card3bglight:hover {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: #f7fffc;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n#card4bglight:hover {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: #f7fffc;\n}\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a, #card1bgdark p,\n#card2bgdark a , #card2bgdark p,\n#card3bgdark a, #card3bgdark p,\n#card4bgdark a, #card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important; \n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $darkTheme_updateBtn;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $darkTheme_updateBtn;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color:  $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover, \n.resetbtn:active, \n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: auto;\npadding: 10px 0;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: auto !important;\n  height: 50px !important;\n  background-color: $primary-color !important;\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border: none !important;\n  padding: .375rem 1rem !important;\n}\n\n.deleteBtn:active, .deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important; \n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover, \n.deleteBtn:active, \n.deleteBtn:focus {\n  background-color: $primary-color !important;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover, \n.confirmBtn:active, \n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n\n.back_dlt{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg{\n  fill: #000; \n}\n\n.bodythemedark .arrowback {\n  background-color: $darkTheme_updateBtn; \n  color: $white-color;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $white-color;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $lightthemetext !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral, \n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) { \n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 998px) { \n  #dashboardcont2{\n    height: auto !important;\n  }\n}\n@media only screen and (max-width: 767px) { \n  .sectionright{\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 20px 10px !important;\n  }\n  .bodythemelight, .bodythemedark {\n    padding-top: 165px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n      max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n      max-width: 350px;\n  }\n}","@import \"../../styles/Variables/Variables.scss\";\n\n#addform{\n\n    width: 100%;\n    border-radius: 5px;\n    margin-top: 30px;\n    padding-bottom:30px;\n\n    #addheading{\n        font-size: 18px;\n        margin-bottom: 20px;\n    }\n\n    .inputbox1{\n        padding: 10px;\n        border: none;\n        border-radius: 5px;\n        width: 100%;\n        background-color: $darkthemecolor;\n        color: $lightthemetext;\n         \n    }\n    .dateinputbox{\n        background-color: $mainBg;\n        border-radius: 5px;\n        width: 100%;\n        color: $black-color;\n        font-size: 14px;\n    }\n    .dateinputbox1{\n        border: none;\n        border-radius: 5px;\n        width: 100%;\n        background-color: $darkthemecolor;\n        color: $lightthemetext;\n    }\n\n    .formbtn{\n        background-color: $primary-btncolor;\n        color: white;\n        border: none;\n        width: 100px;\n        font-size: 16px;\n        padding: 11px;\n        border-radius: 5px;\n        margin-right: 10px;\n\n        &:hover{\n            background-color: $secondary-btncolor;\n        }\n    }\n    .resetbtn{\n        margin-left: 10px;\n        background-color: #b4b8c063;\n        color: #212529;\n        border: none;\n        width: 100px;\n        font-size: 16px;\n        padding: 11px;\n        border-radius: 5px;\n    }\n    .resetbtn:hover{\n        background-color: rgba(37, 105, 109, 0.864);\n        color:#fff;\n    }\n    \n    ::placeholder{\n        font-size: 14px;\n        color: $lightthemetext;\n    }\n    .labeltext{\n        color: $black-color;\n        font-size: 14px;\n        font-weight: 500;\n     }\n      .eyeicon{\n        margin-left: -30px;\n        cursor: pointer;\n      }\n\n      .arrowback{\n        float: right;\n        background-color: #dde2eb;\n        padding: 10px;\n        color: #205440;\n        cursor: pointer;\n        border-radius: 3px;\n\n          &:hover{\n            background-color: #205440;\n            color: #fff;\n          }\n      }\n  }\n  @media only screen and (max-width: 600px) {\n    #dashboardcont2{\n        width: $dashwidth;\n        left: $dashleft;\n        position: relative;\n        padding: $dashboardpadding;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `createUser_dashboard__17yXH`,
	"dashboardContain": `createUser_dashboardContain__frg-z`,
	"bodythemedark": `createUser_bodythemedark__kzglF`,
	"cont2": `createUser_cont2__AUUWk`,
	"top_header": `createUser_top_header__5x0WP`,
	"top_header_inner": `createUser_top_header_inner__WgBlR`,
	"subLink": `createUser_subLink__zgl5e`,
	"footer": `createUser_footer__r8ySe`,
	"bodythemelight": `createUser_bodythemelight__xGFCq`,
	"headerthemelight": `createUser_headerthemelight__9RK3i`,
	"headerthemedark": `createUser_headerthemedark__rbDM+`,
	"menuthemelight": `createUser_menuthemelight__EgxpM`,
	"menuthemedark": `createUser_menuthemedark__e-R6+`,
	"menulinklight": `createUser_menulinklight__Dv14u`,
	"menulinkdarkSelected": `createUser_menulinkdarkSelected__84zB7`,
	"menulinklightSelected": `createUser_menulinklightSelected__34KWF`,
	"menulinkdark": `createUser_menulinkdark__gEw+k`,
	"headinglight": `createUser_headinglight__pb5IY`,
	"headingdark": `createUser_headingdark__+wZmd`,
	"searchboxlight": `createUser_searchboxlight__it2cD`,
	"searchboxdark": `createUser_searchboxdark__zk723`,
	"tableheadlight": `createUser_tableheadlight__zJuDZ`,
	"tableheaddark": `createUser_tableheaddark__93g9w`,
	"table": `createUser_table__+vT8B`,
	"table-borderless": `createUser_table-borderless__zuaEC`,
	"left-section": `createUser_left-section__m6jeo`,
	"tablebodylight": `createUser_tablebodylight__RQHFo`,
	"tablebodydark": `createUser_tablebodydark__+wUQe`,
	"paginationlight": `createUser_paginationlight__vk0cl`,
	"paginationdark": `createUser_paginationdark__Xw1eA`,
	"formthemelight": `createUser_formthemelight__GNCil`,
	"formthemedark": `createUser_formthemedark__c2wJu`,
	"viewformlight": `createUser_viewformlight__5iQFa`,
	"permissionboxlight": `createUser_permissionboxlight__Xbi1l`,
	"permissionboxdark": `createUser_permissionboxdark__tZnnH`,
	"errormsgclr": `createUser_errormsgclr__fZqt+`,
	"graphclrlight": `createUser_graphclrlight__w4ooJ`,
	"graphclrdark": `createUser_graphclrdark__BbVKi`,
	"card1bglight": `createUser_card1bglight__0e+GH`,
	"card1bgdark": `createUser_card1bgdark__olYL6`,
	"card2bglight": `createUser_card2bglight__vgbXZ`,
	"card2bgdark": `createUser_card2bgdark__rXsmA`,
	"card3bglight": `createUser_card3bglight__WUTme`,
	"card3bgdark": `createUser_card3bgdark__hI9mR`,
	"card4bglight": `createUser_card4bglight__1+mIM`,
	"card4bgdark": `createUser_card4bgdark__1zDPP`,
	"actionbtnlight": `createUser_actionbtnlight__DmVva`,
	"actionbtndark": `createUser_actionbtndark__gMi4o`,
	"profiledropdownlight": `createUser_profiledropdownlight__2lQzy`,
	"profiledropdowndark": `createUser_profiledropdowndark__Mvb9k`,
	"settingsection": `createUser_settingsection__JFGnn`,
	"addform": `createUser_addform__c-1fM`,
	"savebtn": `createUser_savebtn__uS9j+`,
	"profile_conatiner": `createUser_profile_conatiner__RVAU1`,
	"ag-theme-alpine": `createUser_ag-theme-alpine__d2lH0`,
	"ag-row": `createUser_ag-row__GzqWr`,
	"formbtn": `createUser_formbtn__7DbRY`,
	"resetbtn": `createUser_resetbtn__wCOLc`,
	"addBtn": `createUser_addBtn__2U3kk`,
	"cust_addBtn": `createUser_cust_addBtn__Z-wC0`,
	"deleteBtn": `createUser_deleteBtn__E04aD`,
	"confirmBtn": `createUser_confirmBtn__3LX0U`,
	"back_dlt": `createUser_back_dlt__T-BCR`,
	"delPopContainer": `createUser_delPopContainer__ernWk`,
	"modal-body": `createUser_modal-body__MHQGK`,
	"delet_icon": `createUser_delet_icon__fXzxB`,
	"arrowback": `createUser_arrowback__lG5yY`,
	"drpdwn_btn": `createUser_drpdwn_btn__DhdKo`,
	"empname": `createUser_empname__ZhmHW`,
	"navitemli": `createUser_navitemli__3afjv`,
	"tabnavli": `createUser_tabnavli__rjxZW`,
	"settingsgeneral": `createUser_settingsgeneral__lu7P9`,
	"settingslinks": `createUser_settingslinks__RRBrS`,
	"dashboardcont2": `createUser_dashboardcont2__nLo41`,
	"sectionright": `createUser_sectionright__v-V2q`,
	"exer_modal_contain": `createUser_exer_modal_contain__KDFCs`,
	"modal-dialog": `createUser_modal-dialog__yVYfJ`,
	"addheading": `createUser_addheading__l+Q6E`,
	"inputbox1": `createUser_inputbox1__X2UXw`,
	"dateinputbox": `createUser_dateinputbox__il7dU`,
	"dateinputbox1": `createUser_dateinputbox1__k6IeO`,
	"labeltext": `createUser_labeltext__vHsyR`,
	"eyeicon": `createUser_eyeicon__LLaA6`
};
export default ___CSS_LOADER_EXPORT___;
